import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as actions from './feed-advice.actions';
import { FeedAdvice, FeedAdviceModuleState, FeedAdviceState } from '../models/feed-advice.model';

export const adapter: EntityAdapter<FeedAdvice> = createEntityAdapter<FeedAdvice>();

export const initialState = <FeedAdviceModuleState>{
  feedadvice: adapter.getInitialState([]),
  isLoaded: false,
  feedAdviceType: null,
  selectedFeedAdvice: null,
  selectedFeedadviceTypes: null,
};

const upsertFeedAdvice = (
  feedAdvices: FeedAdvice[] | null | undefined,
  savedAdvice: FeedAdvice,
) => {
  const currentFeedAdvices = feedAdvices ?? [];
  const hasExistingAdvice = currentFeedAdvices.some(
    (feedAdvice) => feedAdvice.id === savedAdvice.id,
  );

  if (!hasExistingAdvice) {
    return [...currentFeedAdvices, savedAdvice];
  }

  return currentFeedAdvices.map((feedAdvice) =>
    feedAdvice.id === savedAdvice.id ? savedAdvice : feedAdvice,
  );
};

const feedAdviceReducer = createReducer(
  initialState,
  on(actions.clearFeedAdviceState, (state) => ({
    ...state,
    feedadvice: null as FeedAdviceState,
    feedAdvices: null as FeedAdvice[],
    feedAdvicesFromReference: null as FeedAdvice[],
    selectedFeedAdvice: null as FeedAdvice,
    selectedFeedadviceTypes: null as string[],
    isLoaded: false,
  })),
  on(actions.setLocationsForFeedAdvice, (state, { locations }) => ({
    ...state,
    locations,
  })),
  on(actions.loadFeedAdvicesSuccess, (state, { feedAdvices }) => ({
    ...state,
    feedAdvices,
    isLoaded: true,
  })),
  on(
    actions.upsertFeedAdviceSuccess,
    actions.upsertReferenceFeedAdviceSuccess,
    (state, { savedAdvice }) => ({
      ...state,
      feedAdvices: upsertFeedAdvice(state.feedAdvices, savedAdvice),
      selectedFeedAdvice: savedAdvice,
    }),
  ),
  on(
    actions.navigateFromReferenceSuccess,
    (state, { feedAdvicesFromReference, feedAdviceType: type }) => ({
      ...state,
      feedAdvicesFromReference,
      isLoaded: true,
      feedAdviceType: type,
    }),
  ),
  on(actions.navigateCreateFeedAdvice, (state, { feedAdviceType: action }) => ({
    ...state,
    feedAdviceType: action,
  })),
  on(actions.setSelectedFeedAdviceFromReference, (state, { feedAdvice }) => ({
    ...state,
    selectedFeedAdvice: feedAdvice,
  })),
  on(actions.setSelectedFeedAdviceSuccess, (state, { feedAdviceId }) => ({
    ...state,
    selectedFeedAdvice: state.feedAdvices.find((advice) => advice.id === feedAdviceId),
  })),
  on(actions.deleteFeedAdviceSuccess, (state, { feedAdviceId }) => ({
    ...state,
    selectedFeedAdvice: undefined as FeedAdvice,
    feedAdvices: [...state.feedAdvices.filter((c) => c.id !== feedAdviceId)],
  })),
  on(actions.setSelectedCountrySuccess, (state, { id }) => ({
    ...state,
    selectedCountry: id,
  })),
  on(actions.setSelectedFeedadviceTypesSuccess, (state, { types }) => ({
    ...state,
    selectedFeedadviceTypes: types,
  })),
  on(actions.setShowLysineSettingSuccess, (state, { showLysine }) => ({
    ...state,
    showLysine,
  })),
  on(actions.setShowEnergySettingSuccess, (state, { showEnergy }) => ({
    ...state,
    showEnergy,
  })),
  on(actions.setShowDosatorSettingSuccess, (state, { showDosator }) => ({
    ...state,
    showDosator,
  })),
  on(actions.navigateFeedAdviceDetail, (state, { feedAdviceType }) => ({
    ...state,
    feedAdviceType,
  })),
  on(actions.navigateSowsFeedAdviceDetail, (state, { feedAdviceType }) => ({
    ...state,
    feedAdviceType,
  })),
);

export function reducer(state: FeedAdviceModuleState | undefined, action: Action) {
  return feedAdviceReducer(state, action);
}
